"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports._testHook = void 0;

require("whatwg-fetch");

// By default, we will use this endpoint on the PRE to access saved and claimed home data
var DEFAULT_SAVED_HOMES_ENDPOINT = '/personalization/api/SavedHomes.htm';

function convertServerResponseJSONToFetcherResponse(serverResponseJson) {
  var savedHomesResults = [];

  if (!serverResponseJson.error) {
    // first grab the claimed homes
    if (serverResponseJson.claimedHomes) {
      savedHomesResults = serverResponseJson.claimedHomes.map(function (claimedHome) {
        return {
          category: 'CLAIMED_HOME',
          displayName: "Your Home (" + claimedHome.address + ")",
          url: "/homes/" + claimedHome.zpid + "_zpid",
          zpid: claimedHome.zpid
        };
      });
    } // next, add an entry for Saved Homes


    if (serverResponseJson.count) {
      var homeOrHomes = serverResponseJson.count > 1 ? 'homes' : 'home';
      savedHomesResults.push({
        category: 'SAVED_HOME',
        displayName: "Your Saved Homes (" + serverResponseJson.count + " " + homeOrHomes + ")",
        count: serverResponseJson.count
      });
    }
  }

  return savedHomesResults;
}

var SavedHomesFetcher = /*#__PURE__*/function () {
  // constructor
  // argument: urlOverride - a String containing an alternat URL to fetch saved/claimed homes from
  function SavedHomesFetcher(urlOverride) {
    this.baseURL = urlOverride || DEFAULT_SAVED_HOMES_ENDPOINT;
  } // fetchResults
  // returns a Promise that resolves to an array of autocomplete entries


  var _proto = SavedHomesFetcher.prototype;

  _proto.fetchResults = function fetchResults() {
    var fetchOptions = {
      credentials: 'include' // we need to send cookie state for login

    };
    var returnPromise = fetch(this.baseURL, fetchOptions).then(function (response) {
      return response.json();
    }).then(function (json) {
      return convertServerResponseJSONToFetcherResponse(json);
    }).catch(function () {
      return [];
    });
    return returnPromise;
  };

  return SavedHomesFetcher;
}();

var _testHook = {
  convertServerResponseJSONToFetcherResponse: convertServerResponseJSONToFetcherResponse
};
exports._testHook = _testHook;
var _default = SavedHomesFetcher;
exports.default = _default;